var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRecentlyUsedProduct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52,52.75a.7502.7502,0,0,0,.75-.75V28a.7502.7502,0,0,0-.75-.75H28a.7502.7502,0,0,0-.75.75V52a.7502.7502,0,0,0,.75.75Zm-13.25-24h2.5v10.5h-2.5Zm-10,0h8.5V40a.7502.7502,0,0,0,.75.75h4a.7502.7502,0,0,0,.75-.75V28.75h8.5v22.5H28.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40,70.75a30.75,30.75,0,0,0,0-61.5,30.47112,30.47112,0,0,0-21.25,8.53192V12h-1.5v8a.7502.7502,0,0,0,.75.75h8v-1.5H19.39722A28.9906,28.9906,0,0,1,40,10.75,29.25,29.25,0,1,1,10.75,40a28.92523,28.92523,0,0,1,3.26758-13.44678l-1.332-.69043A30.76074,30.76074,0,0,0,40,70.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRecentlyUsedProduct);
export default __webpack_public_path__ + "static/media/icon_recently_used_product.1c01fd0342722aa77d0aeb8e82310511.svg";
export { ForwardRef as ReactComponent };